module.exports = __webpack_public_path__ + "static/img/8.ea21f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/8.png
// module id = IfXJ
// module chunks = 2